import BlogForm from './BlogForm';

import { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { addPost, editPost } from './actions';

const ManageBlog = () => {
  // const { handleChange, handleSubmit, input } = useContext(BlogContext);

  const [input, setInput] = useState({
    id: '',
    title: '',
    content: '',
  });

  // const [edit, setEdit] = useState(false);

  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    id &&
      axios
        .get(`https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`)
        .then((response) => response.data)
        .then((data) => {
          console.log(data);
          setInput({ ...data, title: data.title, content: data.content });
        })
        .catch((error) => console.log(error));
  }, [id]);

  const handleChange = ({ target }) => {
    setInput({ ...input, [target.name]: target.value });
  };

  let history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();

    const datetime = format(new Date(), 'MMMM dd, yyyy pp');

    if (id) {
      axios
        .put(`https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`, {
          title: input.title,
          content: input.content,
        })
        .then((data) => {
          console.log(data);
          dispatch(editPost(input));
        })
        .then(() => history.push('/'))
        .catch((err) => console.log(err));
      // setEdit(false);
      // setInput({
      //   title: '',
      //   content: '',
      // });
    } else {
      // setEdit(false);
      axios
        .post('https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/', {
          title: input.title,
          datetime: datetime,
          content: input.content,
          likes: [],
          comments: [],
        })
        .then((data) => {
          console.log(data.data);

          dispatch(addPost(data.data));
        })
        .then(() => history.push('/'))
        .catch((err) => console.log(err));
      // history.push('/');
      // setInput({
      //   title: '',
      //   content: '',
      // });
    }
  };

  return (
    <div className='blog min-h-screen '>
      <BlogForm
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        input={input}
      />
    </div>
  );
};

export default ManageBlog;
